// Montania.js
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// Importamos los 7 componentes
import HomePresentacion from "../../Jhimbo_home/HomePresentacion";
import HomeServicio from "../../Jhimbo_home/HomeServicio";
import HomeProductos from "../../Jhimbo_home/HomeProductos";
import HomeEleccion from "../../Jhimbo_home/HomeEleccion";
import HomeEquipo from "../../Jhimbo_home/HomeEquipo";
import HomeRedes from "../../Jhimbo_home/HomeRedes";

// Importaciones de imágenes (si las usas de fondo en Montania, si no, muévelas a cada componente)
import image_carrusel_page_3 from "../../../images/banner-default.jpg";
import marca1 from "../../../images/marca-chaqueno.jpeg";
import marca2 from "../../../images/marca-servimotor.jpeg";
import marca3 from "../../../images/marca-total.jpeg";
import marca4 from "../../../images/marca-todomaq.jpeg";
import imagen_producto from "../../../images/imagen_card_prueba.jpeg";
import "../../../css/jhimbo.css"; // tu CSS principal
import { useProveedorVisita } from '../../../components';

export const Montania = ({ setOption, select_val, convertPrice = (() => { }) }) => {
	const { sub_direc } = useParams();
	const { callInformationCompany, nit, themeCompany, loadImageS } = useProveedorVisita() || {};

	const [company_main_data, setCompany_main_data] = useState({});

	const fetchCompanyMainData = async () => {
		const data = await callInformationCompany("main");
		setCompany_main_data(data);
	};

	useEffect(() => {
		fetchCompanyMainData();
	}, [nit]);


	// Estado para manejar el toggle de "Me gusta" (perfil)
	const [liked, setLiked] = useState(false);
	const handleLike = () => {
		setLiked((prev) => !prev);
	};

	// Estado para "seguir" (+ / check)
	const [isFollowed, setIsFollowed] = useState(false);
	const handleClickFollow = () => {
		setIsFollowed(!isFollowed);
	};

	// Carrusel principal (3 imágenes) en "Servicios"
	const images = [image_carrusel_page_3, image_carrusel_page_3, image_carrusel_page_3];
	const [currentIndex, setCurrentIndex] = useState(0);

	const handlePrev = () => {
		setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
	};
	const handleNext = () => {
		setCurrentIndex((prev) => (prev + 1) % images.length);
	};

	// Carrusel de Marcas en "Productos"
	const brands = [
		{ id: 1, name: "Neva", image: marca1 },
		{ id: 2, name: "UjiTools", image: marca2 },
		{ id: 3, name: "DongCheng", image: marca3 },
		{ id: 4, name: "Toyaki", image: marca4 },
		{ id: 5, name: "Dropeski", image: marca1 },
	];
	const [currentIndexBrands, setCurrentIndexBrands] = useState(0);
	const maxIndex = brands.length - 4; // Para no pasarte
	const handlePrevBrands = () => {
		if (currentIndexBrands > 0) {
			setCurrentIndexBrands((prev) => prev - 1);
		}
	};
	const handleNextBrands = () => {
		if (currentIndexBrands < maxIndex) {
			setCurrentIndexBrands((prev) => prev + 1);
		}
	};

	// Listado de productos
	const products = [
		{ code: "TOT-100LT", price: "Bs. 500", description: "Compresora de aire", image: imagen_producto },
		{ code: "TOT-200LT", price: "Bs. 700", description: "Compresora grande", image: imagen_producto },
		{ code: "TOT-200LT", price: "Bs. 700", description: "Compresora grande", image: imagen_producto },
		{ code: "TOT-200LT", price: "Bs. 700", description: "Compresora grande", image: imagen_producto },
		{ code: "TOT-200LT", price: "Bs. 700", description: "Compresora grande", image: imagen_producto },
		{ code: "TOT-200LT", price: "Bs. 700", description: "Compresora grande", image: imagen_producto },
		{ code: "TOT-200LT", price: "Bs. 700", description: "Compresora grande", image: imagen_producto },
		{ code: "TOT-200LT", price: "Bs. 700", description: "Compresora grande", image: imagen_producto },
	];

	return (
		<div className="content-company" key={'company_' + nit}>
			{/* 1) Sección perfil */}

			<HomePresentacion
				infoCompany={company_main_data && company_main_data}
				liked={liked}
				handleLike={handleLike}
				isFollowed={isFollowed}
				handleClickFollow={handleClickFollow}
				current_nit={nit}
				theme={themeCompany}
			/>

			{/* 2) Sección servicio (carrusel 3 imágenes) */}
			<HomeServicio
				images={images}
				defaultImg={image_carrusel_page_3}
				currentIndex={currentIndex}
				handlePrev={handlePrev}
				handleNext={handleNext}
				infoCompany={company_main_data && company_main_data}
			/>

			<HomeProductos
				infoCompany={company_main_data && company_main_data}
				loadImageS={loadImageS}
				convertPrice={convertPrice}
			/>

			<HomeEleccion
				infoCompany={company_main_data && company_main_data}
			/>

			<HomeEquipo
				infoCompany={company_main_data && company_main_data}
			/>

			<HomeRedes
				infoCompany={company_main_data && company_main_data}
			/>
		</div>
	);
};
